import Jobs from './Jobs';
import JobsController from './JobsController';

export { Jobs };

export default JobsController;
